module.exports = __webpack_public_path__ + "3a973b52814839883fd87727cc2b6279.png";